/*
 * Dog Meal "Veggie & Fruit Mix" customiser.
 * Shows the remove-ingredient checkboxes only when the selected variant is the
 * "Plus (+)" option, and rolls the ticked ingredients into a single line-item
 * property ("Remove from mix: Spinach, Apple") so it shows clearly on the order.
 * Markup is rendered by snippets/dog-meal-mix-options.liquid.
 */
(function () {
  if (window.__dogMealMixInit) return;
  window.__dogMealMixInit = true;

  var PLUS_TOKEN = 'Plus (+)';

  function selectedVariantTitle(container) {
    var form = container.closest('form');
    if (!form) return '';
    var select = form.querySelector('select[name="id"], [data-product-select]');
    if (select && select.selectedOptions && select.selectedOptions.length) {
      return select.selectedOptions[0].textContent || '';
    }
    return '';
  }

  function sync(container) {
    var isPlus = selectedVariantTitle(container).indexOf(PLUS_TOKEN) > -1;
    var boxes = container.querySelectorAll('[data-mix-ingredient]');
    var summary = container.querySelector('[data-mix-summary]');

    container.style.display = isPlus ? '' : 'none';

    var removed = [];
    Array.prototype.forEach.call(boxes, function (box) {
      if (!isPlus) box.checked = false;        // never submit removals when not Plus
      if (box.checked) removed.push(box.getAttribute('data-mix-ingredient'));
    });

    if (summary) {
      if (isPlus && removed.length) {
        summary.value = removed.join(', ');
        summary.disabled = false;              // enabled -> submitted with the form
      } else {
        summary.value = '';
        summary.disabled = true;               // disabled -> not submitted (no empty property)
      }
    }
  }

  function syncAll() {
    var containers = document.querySelectorAll('[data-dog-meal-mix]');
    Array.prototype.forEach.call(containers, sync);
  }

  // Re-evaluate after any option/variant change. setTimeout lets the theme's
  // variant picker update select[name="id"] first.
  document.addEventListener('change', function () { setTimeout(syncAll, 0); });

  if (document.readyState !== 'loading') syncAll();
  else document.addEventListener('DOMContentLoaded', syncAll);
})();
